import { Button } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom";
import { useProjectCode } from "../../../hooks/useProjectCode"

export const ProductManagementPage = () => {
  const projectCode = useProjectCode();
  const navigate = useNavigate()
  return (
    <>
      <Button onClick={() => {
        navigate(`/store/${projectCode}/product-create`)
      }}>建立新產品</Button>
    </>
  )
}